module.exports = __webpack_public_path__ + "img/kedaya_icon.994034a7.png";